import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MondayLogoIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "22",
        height: "12",
        viewBox: "0.5 7.8 19 10.4",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M3.63006 17.6733C2.90486 17.6726 2.23716 17.295 1.88618 16.687C1.5352 16.079 1.55623 15.3364 1.94112 14.7475L5.53225 9.25468C5.9011 8.65658 6.57964 8.29733 7.30447 8.31637C8.02929 8.3354 8.68627 8.72974 9.02037 9.3463C9.35446 9.96287 9.31307 10.7046 8.91226 11.2835L5.32326 16.7763C4.95822 17.3352 4.31819 17.6742 3.63006 17.6733Z",
                stroke: "#676879",
                strokeWidth: "0.869565"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.74829 17.6732C9.02429 17.6726 8.35767 17.2958 8.00727 16.6893C7.65686 16.0827 7.67786 15.3419 8.06211 14.7545L11.6463 9.27465C12.0094 8.66783 12.6903 8.29997 13.4206 8.31612C14.1508 8.33228 14.8133 8.72985 15.1467 9.35208C15.4801 9.97431 15.431 10.7213 15.0187 11.2986L11.4345 16.7784C11.0708 17.3348 10.4338 17.6728 9.74829 17.6732Z",
                stroke: "#676879",
                strokeWidth: "0.869565"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.7139 17.6842C16.8107 17.6842 17.6998 16.7966 17.6998 15.7018C17.6998 14.6069 16.8107 13.7193 15.7139 13.7193C14.6171 13.7193 13.728 14.6069 13.728 15.7018C13.728 16.7966 14.6171 17.6842 15.7139 17.6842Z",
                stroke: "#676879",
                strokeWidth: "0.869565"
            })
        ]
    });
